import React from 'react'
import {
  Controller,
  Control,
  UseFormSetValue,
  UseFormGetValues,
} from 'react-hook-form'
import { Button, TextField, Grid, Box } from '@mui/material'
import { Delete } from '@mui/icons-material'

import { FormValues } from '..'
import { useTranslation } from 'react-i18next'
import { EMAIL_REGEX } from 'helpers/constants'
interface PartnerProps {
  nestIndex: number
  control: Control<FormValues>
  setValue: UseFormSetValue<FormValues>
  getValues: UseFormGetValues<FormValues>

  remove: (index?: number | number[] | undefined) => void
}

const Partner = (props: PartnerProps) => {
  const { t } = useTranslation()
  const { control, nestIndex, remove } = props

  return (
    <Box component="fieldset" sx={{ borderRadius: 2.5 }}>
      <Box component="legend" sx={{ px: 0.5 }}>
        {`${t('dashboard.pages.createAgent.partners.partner')} ${
          nestIndex + 1
        }`}
      </Box>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <Controller
            name={`partners.${nestIndex}.contactName` as const}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                variant="outlined"
                label={
                  t('dashboard.pages.createAgent.partners.fields.name') + '*'
                }
                size="small"
                error={!!error}
                helperText={error?.message ?? ''}
                {...field}
              />
            )}
            rules={{
              required: t('validation.fieldRequired') as unknown as string,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name={`partners.${nestIndex}.description` as const}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                label={t(
                  'dashboard.pages.createAgent.partners.fields.description'
                )}
                size="small"
                error={!!error}
                helperText={error?.message ?? ''}
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name={`partners.${nestIndex}.email` as const}
            control={control}
            rules={{
              pattern: {
                value: EMAIL_REGEX,
                message: t('validation.emailPatternError' as string),
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                variant="outlined"
                label="Email*"
                size="small"
                error={!!error}
                helperText={error?.message ?? ''}
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name={`partners.${nestIndex}.mobileNumber` as const}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                variant="outlined"
                label="Τηλέφωνο*"
                size="small"
                error={!!error}
                helperText={error?.message ?? ''}
                {...field}
              />
            )}
          />
        </Grid>

        <Grid item xs="auto">
          <Button
            variant="outlined"
            color="error"
            onClick={() => remove(nestIndex)}
            startIcon={<Delete />}
          >
            {t('dashboard.pages.createAgent.partners.removeButton')}
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Partner
